import { FC, useMemo, useState, useCallback, ComponentProps } from 'react'
import TextButton from 'components/atoms/buttons/TextButton'
import { ADVERTISER_DISCLOSURE } from 'constants/opportunities'
import useRouter from 'hooks/useRouter'
import Popup from 'components/features/pfm/Popup/Popup'

type AdvertiserDisclosureProps =
  & Pick<ComponentProps<typeof TextButton>, 'size' | 'theme'>
  & {

  }

export const AdvertiserDisclosure: FC<AdvertiserDisclosureProps> = (props) => {
  const { size = 'large', theme = 'lowercase' } = props

  const { location } = useRouter()

  const showDisclosurePopup = useMemo(() => {
    return new URLSearchParams(location.search).has('popup')
  }, [location])
  const [isShown, setIsShown] = useState(showDisclosurePopup)

  const handleShowDisclosure = useCallback(() => {
    setIsShown(true)
  }, [])
  const handleHideDisclosure = useCallback(() => {
    setIsShown(false)
  }, [])

  const disclosureChild = useMemo(() => {
    if (!isShown) {
      return null
    }
    return (
      <Popup
        withBottomCloseButton
        title={ ADVERTISER_DISCLOSURE }
        onCloseButtonClick={ handleHideDisclosure }
      >
        <span>
          The offers that appear on this site are from third party advertising partners from which Status Money
          may receive compensation. This compensation is one of several factors that determine the order in which your
          opportunities appear. We don't display every company or financial product available on the market. Compensation
          from advertising partners enable us to keep Status free for everyone.
        </span>
      </Popup>
    )
  }, [isShown, handleHideDisclosure])

  return (
    <>
      <TextButton
        theme={ theme }
        size={ size }
        onClick={ handleShowDisclosure }
      >
        { ADVERTISER_DISCLOSURE }
      </TextButton>
      { disclosureChild }
    </>
  )
}
